import * as DatabaseObjectAppObject from './DatabaseObjectAppObject.svelte';

export default {
  DatabaseObjectAppObject,
};
